import { render, staticRenderFns } from "./ServicePriceDetail.vue?vue&type=template&id=86e1df42&scoped=true&"
import script from "./ServicePriceDetail.vue?vue&type=script&lang=js&"
export * from "./ServicePriceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e1df42",
  null
  
)

export default component.exports